import { Injectable } from '@angular/core';
// eslint-disable-next-line max-len
import { WorkOrder } from '@quorum/models/xs-resource';
import { Actions, createEffect } from '@ngrx/effects';
import { DataPersistence } from '@nrwl/angular';
import { ApiService } from '@quorum/api';
import { map } from 'rxjs/operators';
import {
  WorkOrdersEntityActionTypes,
  GetWorkOrdersFromServer,
  GetWorkOrdersFromServerError,
  GetWorkOrdersFromServerSuccess,
  GetWorkOrderFromServer,
  GetWorkOrderFromServerError,
  GetWorkOrderFromServerSuccess,
  CreateWorkOrderOnServer,
  CreateWorkOrderOnServerError,
  CreateWorkOrderOnServerSuccess,
  UpdateWorkOrderOnServer,
  UpdateWorkOrderOnServerError,
  UpdateWorkOrderOnServerSuccess,
  DeleteWorkOrderFromServer,
  DeleteWorkOrderFromServerError,
  DeleteWorkOrderFromServerSuccess
} from './work-orders.actions';

@Injectable()
export class WorkOrdersEntityEffects {
  
  getWorkOrdersFromServer = createEffect(() => this.dataPersistence.fetch(WorkOrdersEntityActionTypes.GetWorkOrdersFromServer, {
    run: (action: GetWorkOrdersFromServer, state: any) => {
      return this.apiService
        .get<WorkOrder[]>(`v/1/fixed-operations/work-orders`, action.payload)
        .pipe(map(workOrders => new GetWorkOrdersFromServerSuccess(workOrders)));
    },
    onError: (action: GetWorkOrdersFromServer, error) => {
      console.error('Error', error);
      return new GetWorkOrdersFromServerError({ error: error });
    }
  }));

  
  getWorkOrderFromServer = createEffect(() => this.dataPersistence.fetch(WorkOrdersEntityActionTypes.GetWorkOrderFromServer, {
    run: (action: GetWorkOrderFromServer, state: any) => {
      return this.apiService
        .get<WorkOrder>(`v/1/fixed-operations/work-orders/${action.payload.id}`, { params: action.payload.query })
        .pipe(map(workOrder => new GetWorkOrderFromServerSuccess(workOrder)));
    },
    onError: (action: GetWorkOrderFromServer, error) => {
      console.error('Error', error);
      return new GetWorkOrderFromServerError({ error: error });
    }
  }));

  
  updateWorkOrderOnServer = createEffect(() => this.dataPersistence.fetch(WorkOrdersEntityActionTypes.UpdateWorkOrderOnServer, {
    run: (action: UpdateWorkOrderOnServer, state: any) => {
      return this.apiService
        .put<WorkOrder>(`v/1/fixed-operations/work-orders/${action.payload.id}`, action.payload, {
          params: {
            embed: null
          }
        })
        .pipe(map(workOrder => new UpdateWorkOrderOnServerSuccess(workOrder)));
    },
    onError: (action: UpdateWorkOrderOnServer, error) => {
      console.error('Error', error);
      return new UpdateWorkOrderOnServerError({ error: error });
    }
  }));

  
  createWorkOrderOnServer = createEffect(() => this.dataPersistence.fetch(WorkOrdersEntityActionTypes.CreateWorkOrderOnServer, {
    run: (action: CreateWorkOrderOnServer, state: any) => {
      return this.apiService
        .post<WorkOrder>(`v/1/fixed-operations/work-orders/`, action.payload.workOrder, {
          params: action.payload.workOrderQueryParams
        })
        .pipe(
          map(workOrder => {
            return new CreateWorkOrderOnServerSuccess(workOrder);
          })
        );
    },
    onError: (action: CreateWorkOrderOnServer, error) => {
      console.error('Error', error);
      return new CreateWorkOrderOnServerError(error);
    }
  }));

  
  deleteWorkOrderFromServer = createEffect(() => this.dataPersistence.fetch(WorkOrdersEntityActionTypes.DeleteWorkOrderFromServer, {
    run: (action: DeleteWorkOrderFromServer, state: any) => {
      return this.apiService
        .delete<WorkOrder>(`v/1/fixed-operations/work-orders/${action.payload.id}`, action.payload)
        .pipe(
          map(workOrder => {
            return new DeleteWorkOrderFromServerSuccess(workOrder);
          })
        );
    },
    onError: (action: DeleteWorkOrderFromServer, error) => {
      console.error('Error', error);
      return new DeleteWorkOrderFromServerError(error);
    }
  }));

  constructor(
    private actions: Actions,
    private dataPersistence: DataPersistence<any>,
    private apiService: ApiService
  ) {}
}
